import toast from "react-hot-toast";

export function errorResponseHelper(err: any) {
    console.log(err);
    toast.error(err.response.data.message || err.response.data || "Something Went Wrong");
    return false
}